import { render } from "./DatePicker.vue?vue&type=template&id=0c799da6"
import script from "./DatePicker.vue?vue&type=script&lang=ts"
export * from "./DatePicker.vue?vue&type=script&lang=ts"
script.render = render

export default script